(function() {
  'use strict';

  window.MAPTILES_MIN_ZOOM = 5;
  window.MAPTILES_MAX_ZOOM = 15;

  angular
    .module('webAgro1App')
    .factory('MapTilesService', MapTilesService);

  MapTilesService.$inject = [
    '$http',
    '$q',
    'GoogleMapsService'
  ];

  function MapTilesService($http, $q, GoogleMapsService) {
    var service = {
      getTilesData: getTilesData,
      createMapTilesLayer: CreateMapTilesLayer,
      populatePolygons: PopulatePolygons
    };
    return service;

    function getTilesData(propriedade, date, type) {
      type = type === 'todas' ? null : type;
      if (!['ndvi', 'rgb'].includes(type)) {
        return $http({
          url: SERVER + 'v1/ocorrencias/mapa_infestacao/' + propriedade,
          params: {
            data: date,
            tipo: type
          },
          timeout: 15000
        });
      } else {
        return $http({
          url: SERVER + 'v1/mapa_ndvi/' + propriedade,
          params: {
            data: date,
            type: type
          },
          timeout: 15000
        });
      }
    }

    function CreateMapTilesLayer(bounds, url) {
      return $q(function(resolve) {
        var mapOverlay = new google.maps.ImageMapType({
          getTileUrl: function(tile, zoom) {
            if (tileOutOfBounds(tile, zoom)) {
              return null;
            }

            /*jshint bitwise: false*/
            var ymax = 1 << zoom;
            var y = ymax - tile.y - 1;
            var server = SERVER;
            if (url.startsWith('http')) {
              server = '';
            }
            return server + url + '/' + zoom + '/' + tile.x + '/' + y + '.png';
          },
          tileSize: new google.maps.Size(TILE_SIZE, TILE_SIZE),
          maxZoom: MAPTILES_MAX_ZOOM,
          minZoom: MAPTILES_MIN_ZOOM,
          name: 'MapTilesLayer'
        });

        resolve(mapOverlay);
      });

      function tileOutOfBounds(tile, zoom) {
        var neBounds = GoogleMapsService.getTileCoordinate(bounds.getNorthEast(), zoom);
        var swBounds = GoogleMapsService.getTileCoordinate(bounds.getSouthWest(), zoom);
        return zoom < MAPTILES_MIN_ZOOM || zoom > MAPTILES_MAX_ZOOM ||
               neBounds.x < tile.x || neBounds.y > tile.y ||
               swBounds.x > tile.x || swBounds.y < tile.y;
      }
    }

    function PopulatePolygons(polygons, data) {
      return $q(function(resolve) {
        polygons.forEach(function(polygon) {
          if (polygon.gleba && polygon.gleba.id) {
            var resumo = data.resumo.filter(function(d) {
              return d.gleba.id === polygon.gleba.id;
            })[0] || {};
            polygon.tipos_pragas = resumo.tipos_pragas;
            polygon.ultima_pulverizacao = resumo.ultima_pulverizacao;
            polygon.hint = resumo.hint;
          }
        });
        resolve({
          polygons: polygons,
          data: data
        });
      });
    }
  }

}());
